"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDetailParsedRequest = exports.transformDetailParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
function transformDetailParsedResponse(detail) {
    return {
        categoryId: detail.categoryid,
        credit: detail.credit ? Number(detail.credit) : detail.credit,
        currencyCode: detail.currency_code,
        debit: detail.debit ? Number(detail.debit) : detail.debit,
        description: detail.description,
        detailId: detail.detailid,
        id: detail.id,
        name: detail.name,
        subAccountId: detail.sub_accountid,
        userEnteredDate: detail.user_entered_date && (0, Date_1.transformDateResponse)(detail.user_entered_date, Date_1.DateFormat['YYYY-MM-DD'])
    };
}
exports.transformDetailParsedResponse = transformDetailParsedResponse;
function transformDetailParsedRequest(detail) {
    return {
        credit: detail.credit,
        debit: detail.debit,
        sub_accountid: detail.subAccountId,
    };
}
exports.transformDetailParsedRequest = transformDetailParsedRequest;
//# sourceMappingURL=Detail.js.map